module.exports = __webpack_public_path__ + "img/game8.3c4db2f9.png";